import { useCallback, useEffect, useRef } from 'preact/hooks';

import { useVkCaptchaContext } from '../../context/VkCaptchaContext';
import { useWidget } from '../../context/WidgetContext';
import { useVkCaptcha } from '../../hooks/useVkCaptcha';
import { isRateLimitError } from '../../types/guards';
import { tokenManager, setBooleanToStorage } from '../../utils';

import { getAuthCaptchaValidate } from '../../api/getAuthCaptchaValidate';
import { getHasMaxUserPhone } from '../../api/getHasMaxUserPhone';
import { HAS_MAX_USER_PHONE } from '../../constants/localStorage';

import styles from './styles.module.css';

export const Captcha = () => {
  const ref = useRef<HTMLDivElement | null>(null);
  const { handleCaptchaClose, setIsCaptchaPassed } = useVkCaptchaContext();
  const { widgetUuid, setHasMaxUserPhone, requirePhone, setError, localeMessages, locale } = useWidget();

  const onShowCaptchaRef = useRef<(() => void) | null>(null);

  const handleClose = useCallback(
    async (successToken: string) => {
      if (successToken && widgetUuid) {
        const oldToken = tokenManager.getOldToken();

        const response = await getAuthCaptchaValidate({
          successToken,
          widgetUuid,
          oldToken: oldToken ?? undefined,
        });

        if (!response.ok) {
          if (response.status === 500) {
            tokenManager.clearAllAuthAndKeys();

            if (ref.current) {
              ref.current.innerHTML = '';
            }

            setTimeout(() => {
              onShowCaptchaRef.current?.();
            }, 100);
          }
          return;
        }

        setIsCaptchaPassed?.(true);

        tokenManager.setAuthData({
          token: response.token,
          userUuid: response.userUuid,
        });

        // Проверяем наличие телефона, если флаг включен
        if (requirePhone) {
          try {
            const { hasMaxUserPhone } = await getHasMaxUserPhone(response.token);
            setHasMaxUserPhone?.(hasMaxUserPhone);
            // Сохраняем в localStorage для восстановления при перезагрузке
            setBooleanToStorage(HAS_MAX_USER_PHONE, hasMaxUserPhone);
          } catch (error: unknown) {
            if (isRateLimitError(error)) {
              setError?.(localeMessages.errors.rateLimit);
            }
          }
        }

        handleCaptchaClose();
      }
    },
    [handleCaptchaClose, setIsCaptchaPassed, widgetUuid, requirePhone, setHasMaxUserPhone, setError, localeMessages]
  );

  const { onShowCaptcha } = useVkCaptcha(ref, handleClose, locale);
  onShowCaptchaRef.current = onShowCaptcha;

  useEffect(() => {
    void onShowCaptcha();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles.captchaLayer}>
      {/* контейнер для капчи */}
      <div ref={ref} />
    </div>
  );
};
